var map = {
	"./CartDetails": 48,
	"./CartDetails.js": 48,
	"./Contact": 131,
	"./Contact.js": 131,
	"./Home": 122,
	"./Home.js": 122,
	"./ItemMenue": 49,
	"./ItemMenue.js": 49,
	"./ItemMenue_old": 123,
	"./ItemMenue_old.js": 123,
	"./NavBar": 124,
	"./NavBar.js": 124,
	"./NavBarContact": 125,
	"./NavBarContact.js": 125,
	"./NavBarHome": 126,
	"./NavBarHome.js": 126,
	"./Restaurant": 127,
	"./Restaurant.js": 127,
	"./Restaurant_OLD": 128,
	"./Restaurant_OLD.js": 128,
	"./Tastes": 129,
	"./Tastes.js": 129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 132;